<div class="edit-actions">
    <button matTooltip="Cancelar" (click)="cancel()" mat-icon-button class="card-inline">
    <mat-icon>clear</mat-icon>
  </button>
</div>
<mat-tab-group #tabGroup>
    <mat-tab label="Paciente">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <app-patient-crm-patient></app-patient-crm-patient>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Cobranza">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <app-patient-crm-cash-desk></app-patient-crm-cash-desk>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Informes">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <app-patient-crm-study-report></app-patient-crm-study-report>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="HC Consultas">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <app-consultation-history-control [patientId]="patientId"></app-consultation-history-control>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Turnos">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <app-patient-crm-medical-appointment></app-patient-crm-medical-appointment>
            </div>
        </div>
    </mat-tab>
    <mat-tab *ngIf="!canViewMedicalPatientInfo" label="Asignación del caso">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <app-patient-crm-assignment></app-patient-crm-assignment>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>